import {useQueryClient} from '@tanstack/react-query'
import React, {useMemo, useRef} from 'react'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {useAddressInformationCRUD} from '../../address/query-keys/AddressQueryManager'
import {useAuth} from '../../authentication/AuthProvider'
import {genericLogQueryType} from '../generic-log/GenericLogConstansts'
import {contactInformationList} from './StyledDetailInformationConstants'
import StyledDetailInformationSection from './StyledDetailInformationSection'
import {usePatientContext} from './StyleDetailInformationWrapper'

const StyledContactInformationSection = () => {
    const {user} = useAuth()
    const ref = useRef(null)

    const {currentViewedUser} = usePatientContext()

    const {mutateAsync: createOrUpdateAddress} = useAddressInformationCRUD(
        QueryCRUDTypes.update,
        user?.id,
    )

    const queryClient = useQueryClient()

    const {patientKeys} = QueryKeyManager(QueryKeyTypes.patient, user?.id)

    const patientQueryKeys = useMemo(() => {
        return patientKeys.detail({id: currentViewedUser?.id})
    }, [patientKeys, currentViewedUser?.id])

    const handleOnSubmit = async data => {
        let toPostData = {
            ...data,
            id: data?.id || null,
            userId: currentViewedUser?.id,
        }

        const addressInfo = await createOrUpdateAddress(toPostData)

        if (addressInfo?.id) {
            queryClient.invalidateQueries(patientQueryKeys)

            const {genericLogKeys} = QueryKeyManager(
                QueryKeyTypes.genericLog,
                user?.id,
            )
            queryClient.invalidateQueries(
                genericLogKeys.pattern({
                    type: genericLogQueryType.userLog,
                }),
            )

            ref.current.onSuccess()
        }
    }

    return (
        <React.Fragment>
            <div className="col-12 p-0">
                <StyledDetailInformationSection
                    ref={ref}
                    data={currentViewedUser}
                    dataList={contactInformationList}
                    hideLockButton={true}
                    hideRevertButton={true}
                    onSubmit={handleOnSubmit}
                />
            </div>
        </React.Fragment>
    )
}

export default StyledContactInformationSection
